@if (lowestCarbonFlight && lowestCarbonEuroStar) {
  <div class="background-container-background carbon-comparison-container">
    <div class="flex-column-container">
      <div class="flex-column-container">
        <h2 class="carbon_header" i18n="@@carbonComparisonHeader">Carbon Comparison</h2>
        @if (lowestCarbonEuroStar < lowestCarbonFlight) {
          <div>
            <span i18n="@@carbonComparisonEurostarSave">Save</span>&nbsp;{{
              (lowestCarbonFlight - lowestCarbonEuroStar).toFixed()
            }}kg&nbsp;<span i18n="@@carbonComparisonEurostarText"
              >of CO₂ by travelling via Eurostar.</span
            >
          </div>
        }
      </div>
      @if (lowestCarbonEuroStar) {
        <div>
          <div class="flex-column-container">
            <div class="transaction-carbon-container">
              <i class="ico-flight" aria-hidden="true"> </i>
              <div
                class="transaction-carbon-bar"
                [ngClass]="{ high_carbon: lowestCarbonFlight > lowestCarbonEuroStar }"
                [ngStyle]="{
                  width: lowestCarbonFlight < lowestCarbonEuroStar ? getCarbonStyle() : null
                }"
              >
                <span i18n="@@searchFlight">Flight</span> - {{ lowestCarbonFlight.toFixed() }}kg
              </div>
            </div>
            <div class="transaction-carbon-container">
              <i class="custom_icon-eurostar" aria-hidden="true"> </i>
              <div
                class="transaction-carbon-bar"
                [ngClass]="{ high_carbon: lowestCarbonEuroStar > lowestCarbonFlight }"
                [ngStyle]="{
                  width: lowestCarbonEuroStar < lowestCarbonFlight ? getCarbonStyle() : null
                }"
              >
                <span i18n="@@eurostar">Eurostar</span> - {{ lowestCarbonEuroStar.toFixed() }}kg
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
